import styled from 'styled-components'

// borderRadius={'12px'} border='1px solid var(--gray200)'

export const Container = styled.table`
border-radius: 4px;
border: 1px solid var(--gray200);
padding: .5rem 0;
margin-top: 1rem;
font-size: .875rem;
border-spacing: 0 .25rem;
font-family: 'Roboto','sans-serif';
thead{
    tr{
        color: var(--Azul);
    }
    th:first-child{
        padding-left: 4rem;
        text-align: start;
    }
}

tbody{

    tr{
        height:4.125rem;
    }

    tr:nth-child(odd) {
        background-color: #EDF2F7;
    }
    
    tr,th{
        border-collapse: collapse;
        padding: .5rem;
        font-weight: 400;
    }
}
`
